import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_BENEFIT_ITEMS, UPDATE_BENEFIT_ITEMS_SUCCESS, UPDATE_BENEFIT_ITEMS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* UpdateBenefitItems({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefit-group-items`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_BENEFIT_ITEMS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_BENEFIT_ITEMS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_BENEFIT_ITEMS_ERROR, payload: error });
  }
}

export function* watchUpdateBenefitItems() {
  yield takeEvery(UPDATE_BENEFIT_ITEMS, UpdateBenefitItems);
}

function* updateBenefitItemsSaga() {
  yield all([fork(watchUpdateBenefitItems)]);
}

export default updateBenefitItemsSaga;
